module.exports = __webpack_public_path__ + "static/media/No_frachise_found.d9c71937.svg";